'use client';
import { Loader2 } from 'lucide-react';
import { useTranslations } from 'next-intl';
import { useSessionGuardStore } from '@/stores/sessionGuardStore';

export function DisconnectBanner() {
  const t = useTranslations('sessionGuard');
  const blockState = useSessionGuardStore((s) => s.blockState);
  if (blockState !== 'soft') return null;
  return (
    <div
      role="status"
      className="fixed top-0 inset-x-0 z-50 flex items-center justify-center gap-2 bg-amber-100 dark:bg-amber-900/40 text-amber-900 dark:text-amber-100 text-sm font-medium py-1.5 border-b border-amber-300/40"
    >
      <Loader2 className="h-3.5 w-3.5 animate-spin" />
      {t('disconnectBanner.reconnecting')}
    </div>
  );
}
